export interface IntegerResultAndPercentageChangeDTO {
  percentageChange: number | null;
  result          : number;
};

export function IntegerResultAndPercentageChangeDTO_EmptyObject(): IntegerResultAndPercentageChangeDTO {
  return {
    percentageChange: null,
    result          : 0
  }
};
